module.exports = __webpack_public_path__ + "img/retropod.4a1a7b9a.svg";